// extracted by mini-css-extract-plugin
export var searchHeader = "_33-0";
export var searchHeaderDark = "_33-1";